import React from "react";
import SectionContainer from "../../../components/landing/section-container";
import { Typography } from "@mui/material";
import "./footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

function FooterPage() {
  let date = new Date().getFullYear();
  return (
    <SectionContainer id="footer">
      <div className="footer">
        <Stack direction="row" spacing={1} className="footer__fb-btn">
          <Button
            variant="text"
            href="https://www.facebook.com/profile.php?id=61561801993650&mibextid=JRoKGi"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon sx={{ color: "#efb810", marginRight: 1 }} />
            Facebook
          </Button>
          <Button
            variant="text"
            href="https://www.instagram.com/residencia.cactus"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon
              sx={{
                color: "#efb810",
                marginRight: 1,
              }}
            />
            Instagram
          </Button>
        </Stack>
        <Typography>
          © {date} Residencia Cactus | Todos los derechos reservados |
          Desarrollada por Helpbits
        </Typography>
      </div>
    </SectionContainer>
  );
}

export default FooterPage;
